
export const GroupConstant = {
    Group: 'api/Group',
    userGroupsAPI: 'api/UserGroups',
    getAssignmentGroups: '/GetAssignmentGroups'
};